'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _Select = require('calcite-react/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Menu = require('calcite-react/Menu');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OperatorChooser = function OperatorChooser(props) {
  var handleOnChange = function handleOnChange(value) {
    props.onChange((0, _lodash.find)(props.operators, { alias: value }));
  };

  var getOptions = function getOptions(operators) {
    return operators.map(function (operator) {
      return _react2.default.createElement(
        _Menu.MenuItem,
        { value: operator.alias, key: operator.alias },
        operator.alias
      );
    });
  };

  return _react2.default.createElement(
    _Select2.default,
    {
      style: style.select,
      selectedValue: props.selectedOperator && props.selectedOperator.alias,
      disabled: !props.operators.length,
      onChange: handleOnChange
    },
    getOptions(props.operators)
  );
};

var style = {
  select: {
    flex: '0 0 80px'
  }
};

exports.default = OperatorChooser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/components/OperatorChooser.js
// module id = 1576
// module chunks = 0